module.exports = __webpack_public_path__ + "media/images/Amsale-VR-Appt-018f9d2b.webp";